import { render, staticRenderFns } from "./ParentList.vue?vue&type=template&id=c5cec762"
import script from "../../controllers/parent/parent-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/parent/parent-list.js?vue&type=script&lang=js&external"
import style0 from "./ParentList.vue?vue&type=style&index=0&id=c5cec762&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports